/**
 * Entry point para @app/shared
 * Re-exporta todas las utilidades compartidas
 */
module.exports = {
  ...require('./utils/validation'),
  ...require('./utils/dateUtils')
};
